import React from "react";
import "./ChipCustom.scss";
import Chip from "@mui/material/Chip";

const ChipCustom = ({ dataToChip, chipClick }) => {
  const dataChip = dataToChip;
  const isSelected = dataChip.active || false;
  
  const handleClickChip = () => {
    chipClick(dataChip);
  };

  return (
    <>
      {dataChip && (
        <li key={dataChip.key}>
          <Chip
            label={dataChip.label}
            className={`chip-margin ${isSelected ? 'chip-selected' : 'chip-unselected'}`}
            onClick={handleClickChip}
            sx={{
              borderRadius: '20px',
              backgroundColor: isSelected ? '#4caf50' : '#9e9e9e',
              color: isSelected ? 'white' : 'white',
              '&:hover': {
                backgroundColor: isSelected ? '#01A532' : '#E0E0E0',
              }
            }}
          />
        </li>
      )}
    </>
  );
};

export default ChipCustom;
